// JS Plugins

require('jquery-parallax.js'); // Banner image that scrolls away
require('imagesloaded');
require('isotope-layout/dist/isotope.pkgd.min'); // Image layout tool
require('lightbox2'); // Blows up image and greys out background
// Flickity causes problems is inside the Vue #app element
require('flickity'); // Touch responsive flickable carousel
